// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BannerSupplierItem {
  flex-flow: initial;
  overflow: hidden;
  border-radius: var(--border-radius-input);
}
.BannerSupplierItem .BannerSupplierItem-canvas {
  border-radius: var(--border-radius-input);
  width: 100%;
  overflow: hidden;
  height: 206px;
  flex-flow: initial;
}
.BannerSupplierItem img {
  max-width: 100%;
  width: 100%;
  border-radius: var(--border-radius-input);
}
.BannerSupplierItem-loading {
  height: 206px;
  max-width: 100%;
  width: 100vw;
  margin: 2px 0;
}
.BannerSupplierItem-loading .ant-skeleton-button.ant-skeleton-button-round {
  height: 206px;
  max-width: 100%;
  width: 100vw;
}
@media only screen and (min-width: 769px) {
  .BannerSupplierItem {
    max-height: 206px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/BannerSupplier/BannerSupplierStyle.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,yCAAA;AACF;AAJA;EAKI,yCAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AAEJ;AAXA;EAYI,eAAA;EACA,WAAA;EACA,yCAAA;AAEJ;AAEA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;AAAF;AAJA;EAMI,aAAA;EACA,eAAA;EACA,YAAA;AACJ;AAGA;EACE;IACE,iBAAA;EADF;AACF","sourcesContent":[".BannerSupplierItem {\n  flex-flow: initial;\n  overflow: hidden;\n  border-radius: var(--border-radius-input);\n  .BannerSupplierItem-canvas {\n    border-radius: var(--border-radius-input);\n    width: 100%;\n    overflow: hidden;\n    height: 206px;\n    flex-flow: initial;\n  }\n  img {\n    max-width: 100%;\n    width: 100%;\n    border-radius: var(--border-radius-input);\n  }\n}\n\n.BannerSupplierItem-loading {\n  height: 206px;\n  max-width: 100%;\n  width: 100vw;\n  margin: 2px 0;\n  .ant-skeleton-button.ant-skeleton-button-round {\n    height: 206px;\n    max-width: 100%;\n    width: 100vw;\n  }\n}\n\n@media only screen and (min-width: 769px) {\n  .BannerSupplierItem {\n    max-height: 206px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
